import { render } from "./Instruction.vue?vue&type=template&id=132634e4&scoped=true"
import script from "./Instruction.vue?vue&type=script&lang=js"
export * from "./Instruction.vue?vue&type=script&lang=js"

import "./Instruction.vue?vue&type=style&index=0&id=132634e4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/slowko_dnia/slowko_dnia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132634e4"]])

export default __exports__